/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Offset_AddInputs */

const en_transcript_export_offset_add = /** @type {(inputs: Transcript_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const fr_transcript_export_offset_add = /** @type {(inputs: Transcript_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter`)
};

const de_transcript_export_offset_add = /** @type {(inputs: Transcript_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen`)
};

const it_transcript_export_offset_add = /** @type {(inputs: Transcript_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungere`)
};

const ru_transcript_export_offset_add = /** @type {(inputs: Transcript_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавлять`)
};

const es_transcript_export_offset_add = /** @type {(inputs: Transcript_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar`)
};

const zh_cn2_transcript_export_offset_add = /** @type {(inputs: Transcript_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加`)
};

const ja_transcript_export_offset_add = /** @type {(inputs: Transcript_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加`)
};

const hi_transcript_export_offset_add = /** @type {(inputs: Transcript_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जोड़ना`)
};

const pt_pt2_transcript_export_offset_add = /** @type {(inputs: Transcript_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Transcript_Export_Offset_AddInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_offset_add = /** @type {((inputs?: Transcript_Export_Offset_AddInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Offset_AddInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_offset_add(inputs)
	if (locale === "de") return de_transcript_export_offset_add(inputs)
	if (locale === "it") return it_transcript_export_offset_add(inputs)
	if (locale === "ru") return ru_transcript_export_offset_add(inputs)
	if (locale === "es") return es_transcript_export_offset_add(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_offset_add(inputs)
	if (locale === "ja") return ja_transcript_export_offset_add(inputs)
	if (locale === "hi") return hi_transcript_export_offset_add(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_offset_add(inputs)
	return en_transcript_export_offset_add(inputs)
});